import { t } from 'i18next'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import PermissionWrapper from '../../../components/UI/PermissionWrapper/PermissionWrapper'
import {
  CREATE_QUESTION_BANK,
  IMPORTQUESTIONBANK,
  INTEGRATED_SOURCES,
} from '../../../config'
import CreateQuestionFromDocument from './CreateQuestionFromDocument'
import CreateQuestionFromQuestionBank from './CreateQuestionFromQuestionBank'
import { checkIntegration } from '@/routes/Integration/integrationHelpers'
import CustomMenu from '@/components/UI/CustomMenu'

function CreateQuestionsOptions(props: any) {
  const history = useHistory()
  const [createFromDocumentModal, setCreateFromDocumentModal] = useState(false)
  const [createFromQuestionBankModal, setCreateFromQuestionBankModal] =
    useState(false)
  const [isCanvasIntegrated, setIsCanvasIntegrated] = useState({
    intregate: false,
    data: null,
    show: false,
  })

  useEffect(() => {
    checkIntegration({ setIsCanvasIntegrated, isCanvasIntegrated })
  }, [])

  const createQuestionFromDocumentHandler = () => {
    setCreateFromDocumentModal(!createFromDocumentModal)
  }

  const createQuestionFromQuestionBankHandler = () => {
    setCreateFromQuestionBankModal(!createFromQuestionBankModal)
  }

  const addMoreQuestionToQuiz = (question_ids: any[], quizId: any) => {
    props.addMoreQuestionToQuiz(question_ids, quizId)
    createQuestionFromQuestionBankHandler()
  }

  return (
    <>
      <CreateQuestionFromDocument
        open={createFromDocumentModal}
        selectedGroupIdForDocument={props.knowledge_group_ids}
        isEditQuiz={true}
        quizId={props.quizId}
        onClose={createQuestionFromDocumentHandler}
        confirmHandler={() => {}}
        // toolkitSmartQuizAddMoreQue={props.toolkitSmartQuiz}
        queTypes={props.queTypes}
        questionBank={props.questionBank}
        document_Id={props.document_Id}
      />

      <CreateQuestionFromQuestionBank
        show={createFromQuestionBankModal}
        selectedGroupIdForDocument={props.knowledge_group_ids}
        isEditQuiz={true}
        quizId={props.quizId}
        onHide={createQuestionFromQuestionBankHandler}
        confirmHandler={() => {}}
        // toolkitSmartQuizAddMoreQue={props.toolkitSmartQuiz}
        queTypes={props.queTypes}
        addMoreQuestionToQuiz={addMoreQuestionToQuiz}
      />

      <PermissionWrapper>
        <CustomMenu
          textTrigger={`+ ${props.questionBank ? t('Add') : t('Add Question')}`}
          slotProps={{ trigger: { sx: { ml: 'auto' } } }}
          options={[
            {
              label: t('Import from Question bank'),
              hide: props.questionBank,
              onClick: createQuestionFromQuestionBankHandler,
            },
            {
              label: t('Generate from Uploaded Document'),
              onClick: createQuestionFromDocumentHandler,
            },
            {
              label: t('Import from Integration Source'),
              hide: !isCanvasIntegrated.intregate,
              onClick: () => {
                const through = props.questionBank
                  ? `&through=questionBank`
                  : ''
                const group = props.knowledge_group_ids
                  ? `&group=${props.knowledge_group_ids}`
                  : ''
                history.push(
                  `${INTEGRATED_SOURCES}?quizId=${props?.quizId}${through}${group}`,
                  { integrationData: isCanvasIntegrated.data },
                )
              },
            },
            {
              label: t('Upload a test'),
              onClick: () => {
                history.push(
                  IMPORTQUESTIONBANK +
                    '?group=' +
                    props.knowledge_group_ids +
                    '&quizId=' +
                    props?.quizId,
                  {
                    quizId: props?.quizId, //call from create/edit quiz
                  },
                )
              },
            },
            {
              label: t('Create from scratch'),
              onClick: props.addNewQuestion
                ? props.addNewQuestion
                : () => {
                    history.push(
                      CREATE_QUESTION_BANK +
                        '?group=' +
                        props.knowledge_group_ids,
                    )
                  },
            },
          ]}
        />
      </PermissionWrapper>
    </>
  )
}

export default CreateQuestionsOptions
